import React from 'react';
import { Label, Spinner } from '@patternfly/react-core';

const stateMap: Record<string, { label: string; color: 'green' | 'red' | 'orange' | 'grey' }> = {
  running: { label: 'Running', color: 'green' },
  shutoff: { label: 'Shut Off', color: 'red' },
  paused: { label: 'Paused', color: 'orange' },
  shutdown: { label: 'Shutting Down', color: 'orange' },
  crashed: { label: 'Crashed', color: 'red' },
  blocked: { label: 'Blocked', color: 'orange' },
  pmsuspended: { label: 'Suspended', color: 'orange' },
  nostate: { label: 'Unknown', color: 'grey' },
  unknown: { label: 'Unknown', color: 'grey' },
};

const renderPowerStateLabel = (powerState: string | null, isLoading?: boolean) => {
  if (isLoading || powerState === null) {
    return <Spinner size="sm" aria-label="Loading power state" />;
  }

  const entry = stateMap[powerState];
  if (entry) {
    return <Label color={entry.color}>{entry.label}</Label>;
  }
  return <Label color="grey">{powerState}</Label>;
};

export default renderPowerStateLabel;
